module.exports = __webpack_public_path__ + "media/images/site/e-futebol-11368e38a5e29020147956f42e23ee30.png";